import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Field } from 'redux-form';
import { DISPUTES_FLOW } from 'identifiers/identifiers';
import { useReportSelector } from 'components/ReportPage/ReportContext';

import DisputeSelect from '../../../fields/DisputeSelect';

import {
  allSearchRecords,
  formatSearchTitle,
  getChargeTitle,
  getChargeDate,
} from '../lib/screenings';
import { dateIfDate } from '../lib/formatting';

const ChargesByRecordForm = ({ search, trackAction }) => {
  const accountId = useReportSelector(state => state?.account?.id);

  const searchRecordFields = useMemo(() => {
    if (search?.incidents) {
      return search.incidents.map(incident => (
        <Field
          name='charge'
          key={incident.incidentId}
          id={incident.incidentId}
          component={DisputeSelect}
          displayValue={incident.category || 'Unknown incident'}
          className='tile-option-select p-4 mb-2 rounded'
          date={
            incident.incidentDate ? dateIfDate(incident.incidentDate) : null
          }
          subtitle={
            incident.reportingAccountName
              ? `Reported by ${incident.reportingAccountName}`
              : undefined
          }
          selectValue={incident}
          trackAction={trackAction}
        />
      ));
    }

    return allSearchRecords(search).map(record => (
      <Field
        name='charge'
        key={record.id}
        id={record.id}
        component={DisputeSelect}
        displayValue={getChargeTitle(record)}
        className='tile-option-select p-4 mb-2 rounded'
        date={getChargeDate(record)}
        selectValue={record}
        trackAction={trackAction}
      />
    ));
  }, [search, trackAction]);

  const title = search?.incidents ? '' : formatSearchTitle(search, accountId);

  return (
    <div className='mb-4'>
      {title && (
        <div className='mb-2'>
          <b data-testid={DISPUTES_FLOW.disputeChargeSearchTitle}>{title}</b>
        </div>
      )}
      <div>{searchRecordFields}</div>
    </div>
  );
};

ChargesByRecordForm.propTypes = {
  search: PropTypes.object.isRequired,
  trackAction: PropTypes.func.isRequired,
};

export default ChargesByRecordForm;
